import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

export const OrdersTab = () => {
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/admin/orders").then(({ data }) => setOrders(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setShipping = async (order, shipping_status) => {
    try {
      await api.patch(`/admin/orders/${order.id}`, { shipping_status });
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div data-testid="orders-tab">
      <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight uppercase mb-6">Orders ({orders.length})</h2>
      <div className="overflow-x-auto border border-[#2C2623]">
        <table className="w-full text-sm" data-testid="orders-table">
          <thead>
            <tr className="text-left text-[10px] font-mono uppercase tracking-[0.2em] text-[#7A7067] border-b border-[#2C2623]">
              <th className="px-4 py-3">Order</th>
              <th className="px-4 py-3">Customer</th>
              <th className="px-4 py-3">Items</th>
              <th className="px-4 py-3">Total</th>
              <th className="px-4 py-3">Payment</th>
              <th className="px-4 py-3">Shipping</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#2C2623]">
            {orders.map((o) => (
              <tr key={o.id} className="hover:bg-[#1E1A17] transition-colors" data-testid={`order-row-${o.id}`}>
                <td className="px-4 py-3">
                  <p className="font-mono font-bold">#{o.id.slice(0, 8).toUpperCase()}</p>
                  <p className="text-[10px] font-mono text-[#7A7067]">{new Date(o.created_at).toLocaleString()}</p>
                </td>
                <td className="px-4 py-3 text-[#B8AEA5]">{o.email || "—"}</td>
                <td className="px-4 py-3 text-[#B8AEA5]">
                  {o.items.map((i, idx) => (
                    <p key={idx} className="text-xs">{i.name} ({i.size}) x{i.qty}</p>
                  ))}
                  {o.discount_code && <p className="text-[10px] font-mono text-[#E05A36] uppercase mt-1">Code: {o.discount_code}</p>}
                </td>
                <td className="px-4 py-3 font-mono text-[#E29D47]">${o.total.toFixed(2)}</td>
                <td className="px-4 py-3">
                  <span className={`text-[10px] font-mono uppercase tracking-widest px-2.5 py-1 border ${o.status === "paid" ? "text-[#7BC47F] border-[#7BC47F]/40" : "text-[#E29D47] border-[#E29D47]/40"}`} data-testid={`order-status-${o.id}`}>
                    {o.status}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <select
                    value={o.shipping_status}
                    onChange={(e) => setShipping(o, e.target.value)}
                    className="bg-[#0C0A09] border border-[#2C2623] focus:border-[#E05A36] outline-none px-2 py-1.5 text-xs font-mono uppercase tracking-widest transition-colors"
                    data-testid={`order-shipping-${o.id}`}
                  >
                    <option value="pending">Pending</option>
                    <option value="shipped">Shipped</option>
                    <option value="delivered">Delivered</option>
                  </select>
                </td>
              </tr>
            ))}
            {orders.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-12 text-center text-[#7A7067] font-mono text-xs uppercase tracking-widest" data-testid="orders-empty">No orders yet — they appear here after checkout</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
